'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var ipns = require('ipns');

var _require = require('multihashes'),
    fromB58String = _require.fromB58String;

var Record = require('libp2p-record').Record;

var errcode = require('err-code');

var debug = require('debug');

var log = debug('jsipfs:ipns:resolver');
log.error = debug('jsipfs:ipns:resolver:error');
var defaultMaximumRecursiveDepth = 32;

var IpnsResolver =
/*#__PURE__*/
function () {
  function IpnsResolver(routing, repo) {
    _classCallCheck(this, IpnsResolver);

    this._routing = routing;
    this._repo = repo;
    this._resolver = undefined; // TODO Routing - add Router resolver
  }

  _createClass(IpnsResolver, [{
    key: "resolve",
    value: function resolve(name, peerId, options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (typeof name !== 'string') {
        var errMsg = "one or more of the provided parameters are not valid";
        log.error(errMsg);
        return callback(errcode(new Error(errMsg), 'ERR_INVALID_PARAMETER'));
      }

      options = options || {};
      var recursive = options.recursive && options.recursive.toString() === 'true';
      var local = !(options.local === false);
      var nameSegments = name.split('/');

      if (nameSegments.length !== 3 || nameSegments[0] !== '') {
        var _errMsg = "invalid name syntax for ".concat(name);

        log.error(_errMsg);
        return callback(errcode(new Error(_errMsg), 'ERR_INVALID_NAME_SYNTAX'));
      }

      var key = nameSegments[2]; // Define a maximum depth if recursive option enabled

      var depth;

      if (recursive) {
        depth = defaultMaximumRecursiveDepth;
      } // Get the intended resoulver function
      // TODO Routing - set default resolverFn


      var resolverFn;

      if (local) {
        resolverFn = this._resolveLocal;
      }

      if (!resolverFn) {
        return callback(new Error('not implemented yet'));
      }

      this.resolver(key, depth, peerId, resolverFn, function (err, res) {
        if (err) {
          return callback(err);
        }

        log("".concat(name, " was locally resolved correctly"));
        callback(null, res);
      });
    } // Recursive resolver according to the specified depth

  }, {
    key: "resolver",
    value: function resolver(name, depth, peerId, resolverFn, callback) {
      var _this = this;

      // bind resolver function
      this._resolver = resolverFn; // Exceeded recursive maximum depth

      if (depth === 0) {
        var errMsg = "could not resolve name (recursion limit of ".concat(defaultMaximumRecursiveDepth, " exceeded)");
        log.error(errMsg);
        return callback(errcode(new Error(errMsg), 'ERR_RESOLVE_RECURSION_LIMIT'));
      }

      this._resolver(name, peerId, function (err, res) {
        if (err) {
          return callback(err);
        }

        var nameSegments = res.split('/'); // If obtained a ipfs cid or recursive option is disabled

        if (nameSegments[1] === 'ipfs' || !depth) {
          return callback(null, res);
        } // continue recursively until depth equals 0


        _this.resolver(nameSegments[2], depth - 1, peerId, resolverFn, callback);
      });
    } // resolve ipns entries locally using the datastore

  }, {
    key: "_resolveLocal",
    value: function _resolveLocal(name, peerId, callback) {
      var _ipns$getIdKeys = ipns.getIdKeys(fromB58String(name)),
          ipnsKey = _ipns$getIdKeys.ipnsKey;

      this._repo.datastore.get(ipnsKey, function (err, dsVal) {
        if (err) {
          var errMsg = "local record requested was not found for ".concat(name, " (").concat(ipnsKey, ")");
          log.error(errMsg);
          return callback(errcode(new Error(errMsg), 'ERR_NO_LOCAL_RECORD_FOUND'));
        }

        if (!Buffer.isBuffer(dsVal)) {
          var _errMsg2 = "found ipns record that we couldn't convert to a value";
          log.error(_errMsg2);
          return callback(errcode(new Error(_errMsg2), 'ERR_INVALID_RECORD_RECEIVED'));
        }

        var record = Record.deserialize(dsVal);
        var ipnsEntry = ipns.unmarshal(record.value);
        ipns.extractPublicKey(peerId, ipnsEntry, function (err, pubKey) {
          if (err) {
            return callback(err);
          } // IPNS entry validation


          ipns.validate(pubKey, ipnsEntry, function (err) {
            if (err) {
              return callback(err);
            }

            callback(null, ipnsEntry.value.toString());
          });
        });
      });
    }
  }]);

  return IpnsResolver;
}();

exports = module.exports = IpnsResolver;